<template>
  <div class="mso-group-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "msoGroupBase",
};
</script>
